export const LIST_IMPORTED_EXAMS = 'LIST_IMPORTED_EXAMS'
export const SET_IMPORTED_EXAMS = 'SET_IMPORTED_EXAMS'
export const GET_LAST_IMPORTED_AT = 'GET_LAST_IMPORTED_AT'
export const SET_LAST_IMPORTED_AT = 'SET_LAST_IMPORTED_AT'
export const SEARCH_NEW_EXAMS = 'SEARCH_NEW_EXAMS'
export const GET_CANDIDATE_COLLECTIONS = 'GET_CANDIDATE_COLLECTIONS'
export const IMPORT_ERROR_TO_COLLECTION = 'IMPORT_ERROR_TO_COLLECTION'

export const listImportedExams = (options = {}, callback) => ({
  type: LIST_IMPORTED_EXAMS,
  options,
  callback,
})

export const setImportedExams = (payload) => ({
  type: SET_IMPORTED_EXAMS,
  payload,
})

export const getLastImportedAt = () => ({
  type: GET_LAST_IMPORTED_AT,
})

export const setLastImportedAt = (date) => ({
  type: SET_LAST_IMPORTED_AT,
  payload: date,
})

export const searchNewExams = (startDate, endDate, callback) => ({
  type: SEARCH_NEW_EXAMS,
  startDate,
  endDate,
  callback,
})

export const getCandidateCollections = (cpf, callback) => ({
  type: GET_CANDIDATE_COLLECTIONS,
  cpf,
  callback,
})

export const importErrorToCollection = (errorId, collectionId, callback) => ({
  type: IMPORT_ERROR_TO_COLLECTION,
  errorId,
  collectionId,
  callback,
})
